export const icons = {
    'splash': require('../../assets/images/splash.png'),
    'splash_top': require('../../assets/images/splash_top.png'),
    'splash_bottom': require('../../assets/images/splash_bottom.png'),
    'left_arrow': require('../../assets/images/left_arrow.png'),
    'dropdown': require('../../assets/images/dropdown.png'),
    'ad_logo': require('../../assets/images/ad_logo.png'),
    'add_person': require('../../assets/images/add_person.png'),
    'keypass': require('../../assets/images/keypass.png'),
    'messagephone': require('../../assets/images/messagephone.png'),
    'notifiction': require('../../assets/images/notifiction.png'),
    'menu': require('../../assets/images/menu.png'),
    'temp_slider': require('../../assets/images/temp_slider.png'),
    'ad_salamat': require('../../assets/images/ad_salamat.png'),
    'ad_hamkar': require('../../assets/images/ad_hamkar.png'),
    'right_arrow': require('../../assets/images/right_arrow.png'),
    'ad': require('../../assets/images/ad.png'),
    'wallet': require('../../assets/images/wallet.png'),
    'support': require('../../assets/images/support.png'),
    'star_m': require('../../assets/images/star.png'),
    'setting': require('../../assets/images/setting.png'),
    'search': require('../../assets/images/search.png'),
    'requests': require('../../assets/images/requests.png'),
    'pinmap': require('../../assets/images/pinmap.png'),
    'pin': require('../../assets/images/pin.png'),
    'logout': require('../../assets/images/logout.png'),
    'emailbox': require('../../assets/images/emailbox.png'),
    'diamond': require('../../assets/images/diamond.png'),
    'avatar': require('../../assets/images/avatar.png'),
    'back': require('../../assets/images/back.png'),
    'plus': require('../../assets/images/plus.png'),
    'address_pin': require('../../assets/images/pinaddress.png'),
    'temp_zakhm': require('../../assets/images/temp_zakhm.png'),
    'invoice': require('../../assets/images/invoice.png'),
    'remove_account': require('../../assets/images/remove_account.png'),
    'add': require('../../assets/images/add.png'),
    'onmappin': require('../../assets/images/onmappin.png'),
    'edit': require('../../assets/images/edit.png'),
    'remove': require('../../assets/images/remove.png'),
    'more': require('../../assets/images/more.png'),
    'camera': require('../../assets/images/camera.png'),
    'card': require('../../assets/images/cardpay.png'),
    'call': require('../../assets/images/call.png'),
    'star_empty': require('../../assets/images/empty_start.png'),
    'star': require('../../assets/images/start.png'),
    'waiting_expert': require('../../assets/images/waiting_expert.gif'),
    'adhamrah': require('../../assets/images/adhamrah.png'),
    'pathmap': require('../../assets/images/pathmap.png'),
    'target': require('../../assets/images/target.png'),
    'law': require('../../assets/images/law.png'),
    'onmappin_safir': require('../../assets/images/onmappin_safir.png'),
    'take_photo': require('../../assets/images/take_photo.png'),
    'gallery': require('../../assets/images/gallery.png'),
    'expert': require('../../assets/images/expert.png'),
    'like': require('../../assets/images/like.png'),
    'like_fill': require('../../assets/images/like_fill.png'),
    'nurse': require('../../assets/images/nurse.png'),
    'nurse_menu': require('../../assets/images/nurse_menu.png'),
}
